import {StatusLabel, Image} from "~/components";
import {renderDate, numberFormat} from "~/utils";
import {Pagination, Table} from "antd";
import EvaluationAction from "./EvaluationAction";
import {useContext} from "react";
import {AppContext} from "~/context/AppProvider";

const typeLabel = {'3day': '3 ngày', '7day': '7 ngày'};

function EvaluationTable({items = [], pagination, onPaginationChange, onReEvaluate, locked, unlocked, onSetCycle}) {

	const {tableHeight} = useContext(AppContext);

	const columns = [
		{ title: 'Nhân viên', dataIndex: 'user', key: 'user', width: '260px', render: (_, item) => (
			<div className="d-flex gap align-items">
				<div className="avatar"><Image src={item.user?.avatar} /></div>
				<div>
					<b>{item.user ? `${item.user.firstname} ${item.user.lastname}` : `#${item.userId}`}</b>
					<p>{item.user?.username}</p>
					{item.user?.role && <StatusLabel small type={item.user.role.badge}>{item.user.role.label}</StatusLabel>}
				</div>
			</div>
		)},
		{ title: 'Phòng ban / Chức vụ', dataIndex: 'groupName', key: 'groupName', width: '180px', render: (_, item) => (
			<div>
				<b style={{fontSize: 13}}>{item.groupName || '—'}</b>
				{item.user?.role && <p style={{margin: '2px 0 0'}}><StatusLabel small type={item.user.role.badge}>{item.user.role.label}</StatusLabel></p>}
			</div>
		)},
		{ title: 'Loại', dataIndex: 'type', key: 'type', width: '90px', render: (_, item) => (
			<StatusLabel small type={item.type === '3day' ? 'blue' : 'purple'}>{typeLabel[item.type] || item.type}</StatusLabel>
		)},
		{ title: 'Kỳ đánh giá', dataIndex: 'period', key: 'period', width: '210px', render: (_, item) => (
			<div>
				<p>{renderDate(item.startTime)} - {renderDate(item.endTime)}</p>
				<p style={{fontSize: '13px', color: '#999'}}>Ngày đánh giá: {renderDate(item.evaluateTime)}</p>
			</div>
		)},
		{ title: 'Doanh thu / Mốc', dataIndex: 'revenue', key: 'revenue', width: '170px', render: (_, item) => (
			<div>
				<b>{numberFormat(item.revenue)}</b>
				<p style={{fontSize: '13px', color: '#999'}}>Mốc: {numberFormat(item.target)}</p>
			</div>
		)},
		{ title: 'Kết quả', dataIndex: 'status', key: 'status', width: '110px', render: (_, item) => (
			item.status === 'pass'
				? <StatusLabel small type="green">Đạt</StatusLabel>
				: <StatusLabel small type="red">Chưa đạt</StatusLabel>
		)},
		{ title: 'Trạng thái NV', dataIndex: 'userStatus', key: 'userStatus', width: '130px', render: (_, item) => (
			<div>
				{item.user?.locked === 1 && <StatusLabel small type="red">Đang tạm khóa</StatusLabel>}
				{item.user?.locked !== 1 && item.user?.status && <StatusLabel small type={item.user.status.badge}>{item.user.status.label}</StatusLabel>}
			</div>
		)},
		{ title: '#', dataIndex: 'action', key: 'action', width: '160px', render: (_, item) => (
			<EvaluationAction item={item} onReEvaluate={onReEvaluate} locked={locked} unlocked={unlocked} onSetCycle={onSetCycle} />
		)},
	];

	const dataSource = items.map(row => ({ key: row.id, ...row }));

	return (
		<div className="table-wrapper">
			<div className="table-box">
				<Table columns={columns} dataSource={dataSource} scroll={{ y: tableHeight, x: 'max-content' }} pagination={false} />
			</div>
			<Pagination current={pagination.page} defaultCurrent={1} pageSize={pagination.limit} total={pagination.total} onChange={onPaginationChange} showSizeChanger={false} />
		</div>
	);
}

export default EvaluationTable;
